import React, { useState } from "react";
import {
  Box,
  Grid,
  IconButton,
  Typography,
  Button,
  Card,
  CardMedia,
  CardActions,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { X } from "lucide-react";

// Hidden input for file upload
const Input = styled("input")({
  display: "none",
});

export default function MultiImageUpload({setImages, setVideos, title, accept, support, type} : any) {
  const [previewUrls, setPreviewUrls] = useState<string[]>([]);


  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) return;

    const files = Array.from(event.target.files);
    if(type === "video") {
      setVideos((prev :any) => [...prev, ...files]);
    }
    else{
      setImages((prev :any) => [...prev, ...files]);
    }

    const newPreviews = files.map((file) => URL.createObjectURL(file));
    setPreviewUrls((prev) => [...prev, ...newPreviews]);

    // Reset input so the same file can be selected again
    event.target.value = "";
  };

  const handleRemoveImage = (index: number) => {
    if(type === "video") {
      setVideos((prev :any) => prev.filter((_ :any, i : any) => i !== index));
    }
    else{
      setImages((prev :any) => prev.filter((_ :any, i : any) => i !== index));
    }
    setPreviewUrls((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <Box sx={{ width: "100%", margin: "auto", textAlign: "center" }}>
      {/* Upload Button */}
      <label htmlFor={`${type}-upload`}>
        <Input
          accept={accept}
          id={`${type}-upload`}
          multiple
          type="file"
          onChange={handleImageChange}
        //   onDrag={handleImageChange}
        //   onDrop={handleImageChange}
        />
        <Box sx={{ border : "2px dotted #ccc", padding: "10px", borderRadius: "4px", cursor: "pointer" }}>
            <Typography variant="h6" component="div" sx={{ mr: 2 }}>
              <CloudUploadIcon /> {title}
            </Typography>
            <p>{type == "video" ? "Size should be less than 20mb" : "Size should be less than 5mb"}</p>
            <p className="text-xs">Supported formats: {support}</p>
        </Box>
      </label>

      {/* Preview Grid */}
      <Grid container spacing={2} sx={{mt : 2}}>
        {previewUrls.map((url, index) => (
          <Grid size={{ md: 2, sm: 6, xs: 12 }} key={index}>
            <Card sx={{ position: "relative", p : 2, textAlign : "center" }}>
                <Box sx={{ position: "absolute", top: 0, right: 0, cursor: "pointer"}}>
                    <Tooltip title={`Remove ${title}`}>
                        <X onClick={() => handleRemoveImage(index)} color="red" />
                    </Tooltip>
                </Box>
              {type === "image" ? (
                <CardMedia component="img" height="50" image={url} alt={`preview-${index}`} />
              ) : (
                <video
                  controls
                  width="100%"
                  height="120"
                  style={{ borderRadius: 8 }}
                  src={url}
                />
              )}
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
